import React, { useState, useEffect, useContext } from "react";
import styles from "./ChangePassword.module.scss";
import ResetPasswordForm from "../../ResetPasswordForm/ResetPasswordForm";
import { useAuth } from "../../../context/AuthContext";
import { resetPassword } from '../../../utils/api/resetrequestAPI';
import { LanguageContext } from '../../../context/LanguageContext';
import translations from '../../../utils/translations/ChangePasswordTranslations';

const AUTO_DISMISS_MS = 4000; // durée d’affichage du message de succès

const ChangePassword = ({ userId }) => {
  const { user } = useAuth();
  const { language } = useContext(LanguageContext);
  const t = translations[language] || translations.fr;

  const [passwordLoading, setPasswordLoading] = useState(false);
  const [message, setMessage] = useState(null);   // succès
  const [error, setError] = useState(null);       // erreur

  // Auto-dismiss du message de succès
  useEffect(() => {
    if (!message) return;
    const id = setTimeout(() => setMessage(null), AUTO_DISMISS_MS);
    return () => clearTimeout(id); // clean up si le composant se démonte ou si le message change
  }, [message]);

  const handlePasswordSubmit = async (password) => {
    if (!user?.authToken) {
      setError(t.invalidOrExpired);
      return;
    }

    setPasswordLoading(true);
    setMessage(null);
    setError(null);

    try {
      const response = await resetPassword(password, user.authToken);
      if (response.status === "success") {
        setMessage(t.success);
      } else {
        setError(t.errorGeneric);
      }
    } catch {
      setError(t.errorReset);
    } finally {
      setPasswordLoading(false);
    }
  };

  return (
    <>
      <hr className={styles.hr} />
      <h2>{t.title}</h2>

      {/* Message de succès dismissible */}
      {message && (
        <div className={styles.alertSuccess} role="status" aria-live="polite">
          <span>{message}</span>
          <button
            type="button"
            className={styles.closeBtn}
            aria-label={t.dismiss || "Fermer"}
            onClick={() => setMessage(null)}
          >
            ×
          </button>
        </div>
      )}

      {/* Message d’erreur dismissible aussi (optionnel) */}
      {error && (
        <div className={styles.alertError} role="alert" aria-live="assertive">
          <span>{error}</span>
          <button
            type="button"
            className={styles.closeBtn}
            aria-label={t.dismiss || "Fermer"}
            onClick={() => setError(null)}
          >
            ×
          </button>
        </div>
      )}

      <ResetPasswordForm
        onSubmit={handlePasswordSubmit}
        passwordLoading={passwordLoading}
      />
    </>
  );
};

export default ChangePassword;
